import { put, call } from 'redux-saga/effects';
import ExternalSettingsDataRepository from '../../../../data/repositories/ExternalSettingsDataRepository';
import ExternalSettingsRepository from '../../../repositories/ExternalSettingsRepository';
import { Types } from './actions';
import { bannerByDefault } from './banner';

const dataByDefault = [
  {
    id: 1,
    isDefault: true,
    image: bannerByDefault,
    urlRef: ''
  }
];

export default function* saga(): any {
  try {
    yield put({ type: Types.GET_BANNER_LIST_REQUEST });
    const externalSettingsRepository: ExternalSettingsRepository =
      new ExternalSettingsDataRepository();
    const bannerList = yield call(externalSettingsRepository.getBannerList);

    if (!bannerList || bannerList.length === 0) {
      yield put({
        type: Types.GET_BANNER_LIST_SUCCESS,
        data: dataByDefault
      });
      return;
    }

    yield put({
      type: Types.GET_BANNER_LIST_SUCCESS,
      data: bannerList
    });
  } catch (error) {
    yield put({
      type: Types.GET_BANNER_LIST_FAILURE,
      error: 'Ocurrió un error al momento de leer los datos del banner.'
    });
  }
}
